import { LoadIndicator, Popup, TextArea } from "devextreme-react";
import { FormEvent, useEffect, useRef, useState } from "react";
import { closePopup } from "@/helper/DxHelper";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { uqActions } from "@/redux/uq/uq-slice";
import CustomButton from "@/components/CustomButton";
import { TextAreaRef } from "devextreme-react/cjs/text-area";

type Props = {
  data: any;
  popupRef: any;
};

export default function HeaderTitle({ popupRef, data }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const column = useAppSelector((state) => state.uq.header);
  const titles = useAppSelector((state) => state.uq.headerTitles);
  const [value, setValue] = useState();
  const titleRef = useRef<TextAreaRef>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (column) setValue(data[column]);
  }, [column]);

  function saveHandler(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    setIsLoading(true);
    if (column) {
      dispatch(
        uqActions.setTitles({
          ...titles,
          [column]: value,
        })
      );
    }

    dispatch(uqActions.setIsModified(true));
    setIsLoading(false);
    closePopup(popupRef);
  }

  return (
    <Popup
      hideOnOutsideClick={true}
      width={369}
      height="fit"
      ref={popupRef}
      showTitle={false}
      onShown={() => {
        setTimeout(() => {
          titleRef.current?.instance().focus();
        }, 100);
      }}
    >
      <div className="flex flex-col items-center justify-between">
        {isLoading ? (
          <LoadIndicator />
        ) : (
          <form onSubmit={saveHandler} className="w-full">
            <div className="flex flex-col gap-5">
              <TextArea
                ref={titleRef}
                height={144}
                value={value}
                label="Title"
                labelMode="static"
                stylingMode="outlined"
                onValueChanged={(e) => {
                  setValue(e.value);
                }}
              />
              <CustomButton className="mt-4 w-full" text="Save Changes" variant="primary" />
            </div>
          </form>
        )}
      </div>
    </Popup>
  );
}
